export default {
  "Data Record": "డేటా రికార్డ్",
  "My Storage": "మై స్టోరేజ్",
  "Upgrade": "అప్‌గ్రేడ్",
  "Data Size": "డేటా సైజ్",
  "Folders": "ఫోల్డర్స్",
  "Your file is getting upload": "ఫైల్ అప్‌లోడ్ అవుతోంది",
  "Folder Name": "ఫోల్డర్ పేరు",
  "Files": "ఫైల్స్",
  "Rename Folder": "ఫోల్డర్ పేరు మార్చండి",
  "Move Folder": "ఫోల్డర్‌ను మూవ్ చేయండి",
  "Delete Folder": "ఫోల్డర్‌ను తొలగించు",
  "Upload": "అప్‌లోడ్",
  "Create Folder": "ఫోల్డర్‌ను సృష్టించు",
  "Uploading": "అప్‌లోడింగ్",
  "Cancel Uploading": "అప్‌లోడ్‌ను రద్దు చేయి",
  "Are you sure want to cancel?": "మీరు ఖచ్చితంగా రద్దు చేయాలనుకుంటున్నారా?",
  "Yes": "అవును",
  "No": "కాదు",
  "Are you sure want to delete?": "మీరు ఖచ్చితంగా తొలగించాలనుకుంటున్నారా?",
  "Cancel": "రద్దు చేయి",
  "Delete": "తొలగించు",
  "Rename Folder/File": "ఫోల్డర్/ఫైల్ పేరు మార్చండి",
  "Folder  Name / File Name": "ఫోల్డర్ పేరు / ఫైల్ పేరు",
  "Save": "సేవ్",
  "Move File": "ఫైల్ ను మూవ్ చేయండి",
  "Move": "మూవ్",
  "Share": "షేర్",
  "Rename": "పేరుమార్చు",
  "Delete": "తొలగించు",
  "Download": "డౌన్‌లోడ్",
  "No Data Found": "డేటా కనుగొనబడలేదు",
  "Search": "సెర్చ్ ...",
  "uploaded successfully": "అప్‌లోడ్ చేయబడింది",
  "You can share one file at a time": "దయచేసి ఒక ఫైల్‌ను ఒకేసారి షేర్ చేయండి",
  "Choose your folder and click on move here": "ఫోల్డర్‌ను ఎంచుకుని మూవ్ ఫైల్‌ను నొక్కండి",
  "You can download one file at time": "మీరు ఒకేసారి ఒక ఫైల్‌ను డౌన్‌లోడ్ చేసుకోవచ్చు",
  "you can rename one file at a time": "మీరు ఒకేసారి ఒక ఫైల్ పేరు మార్చవచ్చు",
  "Rename successfull": "ఫైల్ పేరు మార్చబడింది",
  "file Deleted Successfully": "ఫైల్ తొలగించబడింది",
  "Load More": "మరింత లోడ్ చేయి",
  "No more Data": "ఇంక డేటా లేదు",
  "Insufficient Memory": "आपके पास पर्याप्त जगह नहीं है"
}